import React, { SyntheticEvent } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  ButtonColorVariant,
  ButtonVariant,
  Color,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

const ButtonStyled = withCitrusTheme(Button, (theme) => ({
  '&:disabled, &:disabled:hover, &:disabled:focus': {
    color: theme.color(Color.White),
  },
}))

export const AddRecipeButton: React.FC<{
  recipeId: string
  setBrowserCTAVisible: () => void
  canAddRecipes: boolean
  addRecipe: (recipeId: string, view: string, recipeInfo: { position?: number }) => void
  removeRecipe: (recipeId: string) => void
  reachedLimit: boolean
  isInBasket: boolean
  isOutOfStock: boolean
  index?: number
}> = ({
  recipeId,
  setBrowserCTAVisible,
  canAddRecipes,
  addRecipe,
  removeRecipe,
  reachedLimit,
  isInBasket,
  isOutOfStock,
  index,
}) => {
  const atLimit = reachedLimit && !isInBasket
  const disabled = isOutOfStock || atLimit

  const buttonAction: React.EventHandler<SyntheticEvent<unknown>> = (e) => {
    e.stopPropagation()

    if (!canAddRecipes) {
      setBrowserCTAVisible()
      return
    }

    if (isInBasket) {
      removeRecipe(recipeId)
    } else {
      addRecipe(recipeId, 'view_recipe_list_screen', { position: index })
    }
  }

  const buttonKeyPressAction: React.KeyboardEventHandler = (e) => {
    e.stopPropagation()

    if (e.keyCode === 13) {
      buttonAction(e)
    }
  }

  return (
    <ButtonStyled
      variant={ButtonVariant.Icon}
      icon={isInBasket ? 'remove' : 'add'}
      colorVariant={isInBasket ? ButtonColorVariant.Secondary : ButtonColorVariant.Primary}
      disabled={disabled}
      onClick={buttonAction}
      onKeyPress={buttonKeyPressAction}
      data-testing={disabled ? 'menuRecipeAddDisabled' : 'menuRecipeAdd'}
      aria-label={isInBasket ? 'Remove recipe' : 'Add recipe'}
    />
  )
}

AddRecipeButton.propTypes = {
  recipeId: PropTypes.string.isRequired,
}
